import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { MyAccount, Welcome, EmployeeDirectory } from "../components/Pages/index";
import { OrganizationalChart } from "../components/Pages/OrganizationalChart/OrganizationalChart";
import { ResetPassword } from "../components/Pages/index";
import HomepageLayout from "../layouts/HomepageLayout";
import OKRs from "../components/Pages/OKRs/OKRs";
import { AddNewOkr } from "../components/Pages/OKRs/Index";
import { ViewOKR } from "../components/Pages/OKRs/ViewOKR/Index";
import OrgChart from "../components/Pages/OrganizationalChart/OrgChart";
import { TrainingHome, UpcomingTraining, MyTraining, TeamTraining } from "../components/Pages/Training/Index";
import MyPerformace from "../components/Pages/PMP/MyPerformance/MyPerformance";
import { Form } from '../components/Pages/PMP/Form/Index';
import { ValueAnalysisList } from '../components/Pages/PMP/ValueAnalysis/ValueAnalysis/Index';
import ValueAnalysisForm from "../components/Pages/PMP/ValueAnalysis/Form/Form";
import { Dashboard } from "../components/Pages/Dashboard/Index";
// import AnnualAppraisal from "../components/Pages/PMP/AnnualAppraisal/AnnualAppraisal";
import AppraisalForm from "../components/Pages/PMP/AnnualAppraisal/AppraisalForm";
import MyOkr from "../components/Pages/OKRs/MyOkr";
import ExternalTraining from "../components/Pages/Training/ExternalTraining";
import AnnualAppraisal from "../components/Pages/PMP/AnnualAppraisal/AnnualAppraisalStructure";

const UnkownRouteHandler = ({ to }) => {
    const prevRoute = useLocation();
    return <Navigate to={to} state={{ prevRoute }} replace />
};

const BaseComponent = (props) => {
    const location = useLocation();
    return (
        // <BrowserRouter>
        <Routes>
            <Route exact path="/" element={<Welcome />} />
            <Route exact path="/home" element={<Welcome />} />
            <Route path="/resetpwd" element={<ResetPassword />} />

            <Route
                path="/resetpassword"
                element={
                    <ResetPassword />
                }
            >
                <Route path=":key" element={<ResetPassword />} />

            </Route>

            <Route element={
                <Authentication redirectTo="/">
                    <HomepageLayout />
                </Authentication>}


            >
                <Route path="/dashboard" element={<EmployeeDirectory />} />
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/myaccount" element={<MyAccount />} />
                <Route path="/orgchart-another" element={<OrganizationalChart />} />
                <Route path="/orgchart" element={<OrgChart />} />
                <Route path="/listokrs" element={<OKRs from={1} />} />
                <Route path="/myokrs" element={<MyOkr from={0} />} />
                <Route path="/viewokr" element={<ViewOKR />} >
                    <Route path=":id" element={<ViewOKR />} />
                </Route>
                <Route path="/add-newokr" element={<AddNewOkr />} />
                <Route path="/employee-directory" element={<EmployeeDirectory />} />
                <Route path="/users-profile" element={<MyAccount />}>
                    <Route path=":id" element={<MyAccount />}></Route>
                </Route>
                <Route path="/training" element={<TrainingHome />} />
                <Route path="/trainings">
                    <Route path="alltrainings" element={<UpcomingTraining />} />
                    <Route path="mytrainings" element={<MyTraining />} />
                    <Route path="team" element={<TeamTraining />} />
                    <Route path="team/externaltrainings" element={<ExternalTraining />} />
                </Route>

                <Route path="/performance" element={<MyPerformace />} />
                <Route path="/form/:id" element={<Form />} />
                <Route path="/value-analysis" element={<ValueAnalysisList />} />
                <Route path="/value-analysis-form/:id" element={<ValueAnalysisForm />} />

                <Route path="/annual-appraisal" element={<AnnualAppraisal />} />
                <Route path="/annual-appraisal-form/:id" element={<AppraisalForm />} />
            </Route>
        </Routes>
        // </BrowserRouter>
    )
}
function Authentication({ children, redirectTo }) {
    const prevRoute = useLocation();

    var userDetails = localStorage.getItem('argus_user') !== null ? localStorage.getItem('argus_user') : null;
    var isAuthenticated = userDetails !== null && JSON.parse(userDetails).accessKey !== null ? true : false;
   
    return isAuthenticated ? children : <Navigate to={redirectTo} state={{ from: prevRoute }} />;
}
export default BaseComponent;